export default {
      id: "i-bar-chart-usage",
      viewBox: "0 0 65 65",
      url: __webpack_public_path__ + "img/sprite.svg#i-bar-chart",
      toString: function () {
        return this.url;
      }
    }